<div class="card">
  <div class="card-body">
    <div>
      <div class="form-body">
        <h5 class="card-title">{{'prodotti.About' | translate}}</h5>
        <hr>
        <div class="row">
          <div class="col-md-4" *ngIf="!AddOn.TranslatedDesc">
            <div class="form-group">
              <label class="control-label">{{'prodotti.name' | translate}}</label>
              <input type="text" id="firstName" [(ngModel)]="Item.prodotto" class="form-control"
                placeholder="{{'prodotti.name' | translate}}">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label">{{'prodotti.Category' | translate}}</label>
              <ng-multiselect-dropdown [settings]="categoriedropdownSettings" style="width: 80%; "
                [placeholder]="'prodotti.Category' | translate" name="categorie" [data]="Categorie"
                [(ngModel)]="CategorieObject" (onFilterChange)="filtroCategoria($event)">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-md-3" *ngIf="AddOn.tipo && Tipologie?.length > 1">
            <div class="form-group">
              <label class="control-label ">{{'prodotti.Type' | translate}}</label>
              <ng-multiselect-dropdown [settings]="unitadropdownSettings" style="width: 80%; "
                [placeholder]="'prodotti.Type' | translate" name="Tipologia" [data]="Tipologie"
                [(ngModel)]="TipologieSelezionate">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-md-3" *ngIf="AddOn.tipi && TipiProdotto?.length > 1">
            <div class="form-group">
              <label class="control-label ">{{'prodotti.Type' | translate}}</label>
              <ng-multiselect-dropdown [settings]="tipiDropdownSettings" style="width: 80%; "
                [placeholder]="'prodotti.Type' | translate" name="Tipologia" [data]="TipiProdotto"
                [(ngModel)]="TipiProdottoSelezionati">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-md-3" *ngIf="environment.ProdottiAddOn['keyaccount']">
            <div class="form-group">
              <label class="control-label ">{{'prodotti.keyaccount' | translate}}</label>
              <ng-multiselect-dropdown [settings]="keyaccountDropdownSettings" style="width: 80%; "
                [placeholder]="'prodotti.keyaccount' | translate" name="Tipologia" [data]="keyaccount"
                [(ngModel)]="Item.clienteObject">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-md-2" *ngIf="AddOn.standby">
            <div class="form-group">
              <label class="control-label ">{{'standby' | translate}}</label>
              <input type="checkbox" id="standby" [(ngModel)]="Item.standby" class="form-control"
                placeholder="{{'prodotti.standby' | translate}}">
            </div>
          </div>
        </div>
        <!--/row-->
        <!--/row-->
        <div class="row">
          <div class="col-sm-12 col-md-3" *ngIf="AddOn.codice">
            <div class="form-group">
              <label for="codice" class="control-label col-form-label">{{'prodotti.Codice' | translate}}</label>
              <input [(ngModel)]="Item.codice" type="text" class="form-control" id="codice"
                placeholder="{{'prodotti.Codice' | translate}}">
            </div>
          </div>
          <div class="col-sm-12 col-md-3" *ngIf="AddOn.codice_produttore">
            <div class="form-group">
              <label for="codice_produttore" class="control-label col-form-label">{{'prodotti.CodiceP' |
                translate}}</label>
              <input [(ngModel)]="Item.codice_produttore" type="text" class="form-control" id="codice_produttore"
                placeholder="{{'prodotti.CodiceP' | translate}}">
            </div>
          </div>
          <div class="col-sm-12 col-md-3" *ngIf="AddOn.video">
            <div class="form-group">
              <label for="video" class="control-label col-form-label">{{'prodotti.video' | translate}}</label>
              <input [(ngModel)]="Item.video" type="text" class="form-control" id="video"
                placeholder="{{'prodotti.Video' | translate}}">
            </div>
          </div>
          <!--              <div class="col-sm-12 col-md-1" *ngIf="AddOn.classeEnergetica">-->
          <!--                <div class="form-group">-->
          <!--                  <label for="catEnergetica" class="control-label col-form-label">{{'prodotti.energyCat' | translate}}</label>-->
          <!--                  <input [(ngModel)]="Item.catEnergetica" type="text" class="form-control" id="catEnergetica" placeholder="{{'prodotti.energyCat' | translate}}">-->
          <!--                </div>-->
          <!--              </div>-->
          <div class="col-md-3" *ngIf="AddOn.classeEnergetica">
            <div class="form-group">
              <label class="control-label ">{{'prodotti.energyCat' | translate}}</label>
              <ng-multiselect-dropdown [settings]="unitadropdownSettings" style="width: 80%; "
                [placeholder]="'prodotti.energyCat' | translate" name="CENER" [data]="ClassiEnergetiche"
                [(ngModel)]="ClassiEnergeticheSelezionate">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-sm-12 col-lg-3" *ngIf="AddOn.codAdhoc">
            <div class="form-group">
              <label for="adhoc" class="control-label col-form-label">{{'adhocCode' | translate}}:</label>
              <input [(ngModel)]="Item.codiceAdhoc" type="text" class="form-control" id="adhoc"
                placeholder="{{'adhocCode' | translate}}">
            </div>
          </div>
          <div class="col-sm-12 col-lg-3" *ngIf="AddOn.sottoTitolo">
            <div class="form-group">
              <label for="Sottotitolo" class="control-label col-form-label">{{'Sottotitolo' | translate}}:</label>
              <input [(ngModel)]="Item.sottoTitolo" type="text" class="form-control" id="Sottotitolo"
                placeholder="{{'Sottotitolo' | translate}}">
            </div>
          </div>
          <div class="col-sm-12 col-lg-3" *ngIf="AddOn['rifornimento']">
            <div class="form-group">
              <label for="rifornimento" class="control-label col-form-label">{{'prodotti.rifornimento' |
                translate}}:</label>
              <input [(ngModel)]="Item.rifornimento" min="0" step="1" type="number" class="form-control"
                id="rifornimento" placeholder="{{'prodotti.rifornimento' | translate}}">
            </div>
          </div>
          <div class="col-sm-12 col-lg-2" *ngIf="AddOn['prezzoSingolo']">
            <div class="form-group">
              <label for="prezzo" class="control-label col-form-label">{{'prodotti.prezzo' | translate}}:</label>
              <input [(ngModel)]="Item.prezzo" min="0" step="1" type="number" class="form-control" id="prezzo"
                placeholder="{{'prodotti.prezzo' | translate}}">
            </div>
          </div>
          <div class="col-sm-12 col-lg-1" *ngIf="AddOn['prezzoSingolo']">
            <div class="form-group">
              <label for="iva" class="control-label col-form-label">{{'prodotti.iva' | translate}}:</label>
              <input [(ngModel)]="Item.iva" min="0" step="1" type="number" class="form-control" id="iva"
                placeholder="{{'prodotti.iva' | translate}}">
            </div>
          </div>
          <div *ngIf="AddOn['CampiAggiuntivi']" class="col-12">
            <app-field-viewer [(Oggetto)]="Item" [(Campi)]="AddOn['CampiAggiuntivi']" (OnChange)="Change($event)"
              [(DropdownSources)]="DropdownSources"></app-field-viewer>
          </div>
          <!--              <ng-container *ngFor="let campo of AddOn['CampiAggiuntivi']">-->
          <!--                -->
          <!--                <div [ngClass]="campo.class" [ngStyle]="campo.style">-->
          <!--                  <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">-->
          <!--                    <ng-template [ngIf]="campo.type != 'object' ">-->
          <!--                      <label  class="control-label col-form-label">{{campo.nome | translate}}:</label>-->
          <!--                      <input [type]="campo.inputType"  [(ngModel)]="Item[oggetto]" [readonly]="!campo.modificabile"  class="form-control"> &nbsp;-->
          <!--                    </ng-template>-->
          <!--                    <ng-template [ngIf]="campo.type == 'object'  &&  Item[oggetto]">-->
          <!--                      <label class="control-label col-form-label">{{campo.nome | translate}}:</label>-->
          <!--                      <input [type]="campo.inputType"  [(ngModel)]="Item[oggetto][campo.field[i]]" [readonly]="!campo.modificabile" class="form-control"> &nbsp;-->
          <!--                    </ng-template>-->
          <!--                  </ng-container>-->
          <!--                </div>-->
          <!--              </ng-container>-->


        </div>
        <div *ngIf="UnitaDiMisura && UnitaDiMisura.length > 0 && !AddOn['prezzoSingolo']" class="row">
          <div class="col-12">
            <br>
            <h5>Inserire uno o piu prezzi nella lista</h5>
          </div>

          <div class="input-group col-sm-12 col-md-4" *ngIf="UnitaDiMisura.length > 1">
            <ng-multiselect-dropdown [settings]="unitadropdownSettings"
              *ngIf="UnitaDiMisura && UnitaDiMisura.length > 0" style="width: 80%; "
              [placeholder]="'prodotti.um' | translate" name="um" [data]="UnitaDiMisura"
              [(ngModel)]="UnitaDiMisuraSelezionata">
            </ng-multiselect-dropdown>
          </div>
          <div class="input-group col-sm-6 col-md-3">
            <div class="">
              <label class="input-group-text">{{'prodotti.Price' | translate}}</label>
            </div>
            <input type="number" [(ngModel)]="prezzo" name="prezzo" class="form-control">
          </div>
          <div class="col-sm-12 col-md-1">
            <div class="form-group">
              <!--                  <label for="iva" class="control-label col-form-label">{{'prodotti.iva' | translate}}</label>-->
              <input [(ngModel)]="Item.iva" type="number" min="0" max="100" step="1" class="form-control" id="iva"
                placeholder="{{'prodotti.iva' | translate}}">
            </div>
          </div>
          <div class=" mt-3 mt-md-0 d-flex align-items-center p-1">
            <button class="btn btn-outline-success rounded-pill" style="width: 100%;" (click)="addPrezzo()"
              type="button">{{'prodotti.aggiungi' | translate}}</button>
          </div>
        </div>
        <div *ngIf="Item && !AddOn['prezzoSingolo']" class="table-responsive">
          <table class="table bg-white table-hover align-middle mb-0 no-wrap">
            <thead>
              <tr>
                <th>{{'prodotti.Price' | translate}}</th>
                <th scope="col">{{'prodotti.um' | translate}}</th>
                <th scope="col">{{'prodotti.Actions' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let co of Item?.prezzi">
                <td>
                  <!-- <img [src]='co.Imagepath' class="rounded-circle mr-2" alt="" height="45" width="45"> -->
                  <span class="text-dark font-medium font-16">
                    <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                      <i class="fas fa-euro-sign"></i>
                    </span>
                    {{ co.prezzo}} €
                  </span>
                </td>
                <td class="align-middle">
                  <span>
                    <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
                      <i class="fas fa-barcode"></i>
                    </span>
                    {{ co.umlabel}}
                  </span>
                </td>
                <td class="align-middle">
                  <a href="javascript:void(0)" class="link text-danger font-16 font-weight-bold"
                    (click)='deletePrezzo(co)'>
                    <i-feather name="trash-2" class="feather-sm"></i-feather>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--/row-->
        <h5 class="card-title m-t-40" *ngIf="AddOn.shortDescription && !AddOn.TranslatedDesc">
          {{'prodotti.shortDescription' | translate}}</h5>
        <div *ngIf="AddOn.shortDescription && !AddOn.TranslatedDesc" class="row">
          <div class="col-md-12 ">
            <div class="form-group">
              <textarea class="form-control" maxlength="1020" rows="4" [(ngModel)]="Item.descrizioneBreve"></textarea>
            </div>
          </div>
        </div>
        <h5 class="card-title m-t-40">{{'prodotti.descrizione' | translate}}</h5>
        <div class="row" *ngIf="!AddOn.TranslatedDesc">
          <div class="col-md-12 ">
            <div class="form-group">
              <textarea class="form-control" rows="4" [(ngModel)]="Item.descrizione"></textarea>
            </div>
          </div>
        </div>
        <app-translated-desc *ngIf="AddOn.TranslatedDesc" [col4]="true"
          [(data)]="Item.transaltedobjects"></app-translated-desc>
        <!--/row-->

        <div class="row" *ngIf="Taglie.length > 0">
          <div class="col-md-2 p-3 " *ngFor="let taglia of Taglie">
            <div class="d-flex justify-content-center align-items-center"
              style="border: 1px solid lightgray; padding: 0.50rem; border-bottom: none; background-color: rgba(0,0,0,0.1);">
              <span class="font-16">{{taglia.taglia}}</span>

            </div>
            <div class="d-flex justify-content-center align-items-center p-2"
              style="border: 1px solid lightgray; border-bottom: none; background-color: rgba(0,0,0,0.1);">
              <input type="checkbox" class="" [(ngModel)]="taglia.selected">
            </div>
            <div class="d-flex justify-content-center align-items-center"
              style="border: 1px solid lightgray; padding-inline: 3rem; padding-block: 10px; background-color: rgba(0,0,0,0.1);">
              <input type="number" class="form-control" placeholder="Magazzino" [(ngModel)]="taglia.magazzino"
                *ngIf="taglia.selected">
            </div>
          </div>
        </div>
        <div class="row">
          <!--/span-->
          <div class="col-md-3">
            <h5 class="card-title m-t-20">{{'prodotti.UploadImage' | translate}}</h5>
            <div class="el-element-overlay">
              <div class="el-card-item">
                <div class="el-card-avatar el-overlay-1">
                  <img *ngIf="Item.UrlImmagine || Item.immagine"
                    [src]="Item.immagine ? Item.immagine : Item.UrlImmagine" (error)="onImageError(Item)" alt="user" />
                  <div class="el-overlay">
                    <ul class="list-style-none el-info">
                      <li class="el-item" *ngIf="Item.UrlImmagine">
                        <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="Item.UrlImmagine">
                          <i class="icon-magnifier"></i>
                        </a>
                      </li>
                      <li class="el-item">
                        <a class="btn default btn-outline el-link" href="javascript:void(0);">
                          <i class="icon-link"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn btn-info waves-effect waves-light">
              <span>Upload Anonther Image</span>
              <input type="file" class="upload" (change)="ImageChange($event, 'immagine', 'image', 'file')">
            </div>
          </div>
          <div class="col-md-3" *ngIf="AddOn.tags">
            <h5 class="card-title m-t-20">{{'prodotti.UploadScheda' | translate}}</h5>
            <div class="el-element-overlay">
              <div class="el-card-item">
                <div class="el-card-avatar el-overlay-1">
                  <img *ngIf="Item.Urlscheda || Item.scheda" [src]="Item.scheda ? Item.scheda : Item.Urlscheda"
                    (error)="onschedaError(Item)" alt="user" />
                  <div class="el-overlay">
                    <ul class="list-style-none el-info">
                      <li class="el-item">
                        <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="Item.Urlscheda">
                          <i class="icon-magnifier"></i>
                        </a>
                      </li>
                      <li class="el-item">
                        <a class="btn default btn-outline el-link" href="javascript:void(0);">
                          <i class="icon-link"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn btn-info waves-effect waves-light">
              <span>Upload {{ Item.Urlscheda || Item.scheda ? 'Anonther' : 'An'}} Image</span>
              <input type="file" class="upload" (change)="ImageChange($event, 'scheda', 'image', 'filescheda')">
            </div>
            <div class="btn btn-info waves-effect waves-light" style="margin-inline: Auto">

              <input type="file" class="custom-file-input" id="pdf"
                placeholder="{{Item.id_pdf_scheda ? 'Modifica Pdf' : 'Carica Pdf'}}"
                (change)="ImageChange($event, 'pdf_scheda', 'pdf','filepdf_scheda')">
              <label class="custom-file-label" for="pdf">{{Item.id_pdf_scheda ? 'Modifica Pdf' : 'Carica Pdf'}}
                {{Item.filepdf_scheda ?? ''}}</label>
              <!--                  <input type="file" class="upload" placeholder="{{Item.filepdf_scheda ?? 'Nessun File caricato'}}"   (change)="ImageChange($event, 'pdf_scheda', 'pdf','filepdf_scheda')">-->
            </div>

          </div>
          <div class="col-md-3" *ngIf="AddOn.dettaglio">
            <h5 class="card-title m-t-20">{{'prodotti.dettagli' | translate}}</h5>
            <div class="el-element-overlay">
              <div class="el-card-item">
                <div class="el-card-avatar el-overlay-1">
                  <img *ngIf="Item.Urldettagli || Item.dettaglio"
                    [src]="Item.dettaglio ? Item.dettaglio : Item.Urldettagli" (error)="onschedaError(Item)"
                    alt="user" />
                  <div class="el-overlay">
                    <ul class="list-style-none el-info">
                      <li class="el-item">
                        <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="Item.Urldettagli">
                          <i class="icon-magnifier"></i>
                        </a>
                      </li>
                      <li class="el-item">
                        <a class="btn default btn-outline el-link" href="javascript:void(0);">
                          <i class="icon-link"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn btn-info waves-effect waves-light">
              <span>Upload Anonther Image</span>
              <input type="file" class="upload" (change)="ImageChange($event, 'dettaglio', 'image','filedettaglio')">
            </div>
          </div>
          <div class="col-md-3" *ngIf="AddOn.classeEnergetica">
            <h5 class="card-title m-t-20">{{'prodotti.energyCat' | translate}}</h5>
            <div class="el-element-overlay">
              <div class="el-card-item">
                <div class="el-card-avatar el-overlay-1">
                  <img *ngIf="Item.Urlscheda_e || Item.scheda_e"
                    [src]="Item.scheda_e ? Item.scheda_e : Item.Urlscheda_e" (error)="onschedaError(Item)" alt="user" />
                  <div class="el-overlay">
                    <ul class="list-style-none el-info">
                      <li class="el-item">
                        <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="Item.Urlscheda_e">
                          <i class="icon-magnifier"></i>
                        </a>
                      </li>
                      <li class="el-item">
                        <a class="btn default btn-outline el-link" href="javascript:void(0);">
                          <i class="icon-link"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn btn-info waves-effect waves-light">
              <span>Upload Anonther Image</span>
              <input type="file" class="upload" (change)="ImageChange($event, 'scheda_e', 'image','filescheda_e')">
            </div>
          </div>
          <div class="col-md-3" *ngIf="AddOn['logo']">
            <h5 class="card-title m-t-20">{{'Logo Aggiuntivo' | translate}}</h5>
            <div class="el-element-overlay">
              <div class="el-card-item">
                <div class="el-card-avatar el-overlay-1">
                  <img *ngIf="Item['Urllogo'] || Item['logo']" [src]="Item['logo'] ? Item['logo'] : Item['Urllogo']"
                    (error)="onschedaError(Item)" alt="user" />
                  <div class="el-overlay">
                    <ul class="list-style-none el-info">
                      <li class="el-item">
                        <a class="btn default btn-outline image-popup-vertical-fit el-link" [href]="Item['Urllogo']">
                          <i class="icon-magnifier"></i>
                        </a>
                      </li>
                      <li class="el-item">
                        <a class="btn default btn-outline el-link" href="javascript:void(0);">
                          <i class="icon-link"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="btn btn-info waves-effect waves-light">
              <span>Upload Anonther Image</span>
              <input type="file" class="upload" (change)="ImageChange($event, 'logo', 'image','filelogo')">
            </div>
          </div>
        </div>
        <div class="row" *ngIf="AddOn.tags">
          <h5 class="card-title m-t-40">{{'prodotti.schedatecnica' | translate}}</h5>
          <div class="col-12">
            <app-scheda-tecnica-prodotto [(items)]="Item.tags"></app-scheda-tecnica-prodotto>
          </div>
        </div>


        <!--            <div class="row" *ngIf="Item.id && AddOn.dettaglio">-->
        <!--              <h5 class="card-title m-t-40">{{'prodotti.dettagli' | translate}}</h5>-->
        <!--              <div class="col-12">-->
        <!--                <app-product-highlights [(dettagli)]="Item.dettagli" [(id_prodotto)]="Item.id" [viewMode]="'edit'" (Refresh)="Refresh(Item.id)"></app-product-highlights>-->
        <!--              </div>-->
        <!--            </div>-->
      </div>

    </div>
  </div>
</div>
<div class="card" *ngIf="AddOn['prodottiCorrelati']">
  <div class="card-body">
    <h5 class="card-title">{{'prodotti.prodottiCorrelati' | translate}}</h5>
    <app-prodotti-correlati [(items)]="Item.correlatiObject"></app-prodotti-correlati>
  </div>
</div>
<div class="card" *ngIf="AddOn['Ricambi']">
  <app-ricambi-list [(prodotto)]="Item" [Tipo]="AddOn['Ricambi'].id"></app-ricambi-list>
</div>
<div class="card" *ngIf="environment.Modules['DistintaBase'] && environment.Modules['FoodCost']">
  <app-materiali-prodotto-list [(schedas)]="Item['schede']"></app-materiali-prodotto-list>
  <br>
  <br>
  <br>
  <br>
  <br>
  <br>
</div>
<div class="card">
  <div class="card-body">
    <div class="form-actions ml-auto m-t-40">
      <button type="submit" class="btn btn-success" (click)="saveClick()">
        <i class="fa fa-check "></i> {{'prodotti.Save' | translate}}
      </button>
      <button type="submit" class="btn btn-success" (click)="saveClick(true)">
        <i class="fa fa-check"></i> {{'saveAndClose' | translate}}
      </button>
      <app-stampa [Stampe]="Item.stampe" *ngIf="Item?.stampe?.length > 0"></app-stampa>
      <button type="button" class="btn btn-dark" (click)="cancel()">{{'prodotti.cancel' | translate}}</button>
    </div>
  </div>
</div>
<div *ngIf="Item.id && AddOn.files" class="card">
  <app-file-uploader #fileUpload [externalUploadFunc]="true" [url]="'/prodotti/file'" [(id)]="Item.id"
    (onUploadButtonClick)="FileUploadButtonClick($event)" (onChange)="onFileChanged()"></app-file-uploader>
</div>